<template>
  <div class="row">
    <div class="page-title">
      <div class="row">
        <div class="col-sm-6 col-12">
          <h2>
            Geo Zones
          </h2>
        </div>
        <div class="col-sm-6 col-12 text-end">
          <a class="btn btn-primary align-items-center" href="/admin/geozones/new">
            <i class="fa-regular fa-square-plus"></i>
            Add New
          </a>
        </div>
      </div>
    </div>

    <div class="col-xl-12 xl-100 box-col-6">
      <div class="card">
        <div class="card-body social-list filter-cards-view">
          <div>
            <DataTable
              :ajax="{ url: `/api/datatable/geo-zones` }"
              ref="geoZonesDataTable" class="table-responsive display" :columns="geoZoneColumns" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import DataTable from 'datatables.net-vue3';
import DataTablesCore from 'datatables.net-bs5';
import {activeBadgeRender, geoZoneType} from '../utility/DatatableRenderer';

DataTable.use(DataTablesCore);

const geoZonesDataTable = ref(null);


// GeoZone datatable columns
const geoZoneColumns = [
  { data: 'name', title: 'Name' },
  {data:'zoneType', title: 'Type', render: geoZoneType },
  { data: 'active', title: 'Status', render: activeBadgeRender },
  { title: 'Action', orderable: false, searchable: false, render:  (data, type, row, meta) => {
    return `<a class="btn btn-sm btn-outline-primary"href="/admin/geozones/${row.id}">
                <i class="fas fa-pen-to-square"></i> Edit</a>`}
  }
];

</script>
